export default __webpack_public_path__ + "static/banner_back-dd06ec4077bf2dedefa8c4cafff2431a.webp";